import React, { Children } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { compose, withStateHandlers } from 'recompose';


import Tab from './Tab';
import TabContent from './TabContent';

import './tabCarousel.scss';

export const enhance = compose(
	withStateHandlers(
		({ initialSelectedTab = 0 }) => ({
			selectedTab: initialSelectedTab
		}),
		{
			selectTab: () => (selectedTabIndex) => ({
				selectedTab: selectedTabIndex
			})
		}
	)
);

export function TabCarousel({ tabs, tabContent, selectedTab, selectTab, className }) {
	return (
		<div className={classnames(className, 'tab-carousel')}>
			<div className={classnames('tab-carousel-tabs')}>
				{Children.toArray(tabs.map((tab, i) => (
					<Tab
						onClick={() => selectTab(i)}
						selected={selectedTab === i}
					>
						{tab}
					</Tab>
				)))}
			</div>
			<div className={classnames('tab-carousel-content-blocks')}>
				{Children.toArray(tabContent.map((content, i) => (
					<TabContent
						selected={selectedTab === i}
					>
						{content}
					</TabContent>
				)))}
			</div>
		</div>
	);
}

TabCarousel.propTypes = {
	className: PropTypes.string,
	tabs: PropTypes.arrayOf(PropTypes.node),
	tabContent: PropTypes.arrayOf(PropTypes.node),
	selectedTab: PropTypes.number,
	selectTab: PropTypes.func
};

TabCarousel.defaultProps = {
	tabs: [],
	tabContent: []
};

export default enhance(TabCarousel);
